export default {
  "content": "<path d=\"M3.5 19h4v2h-5l-.103-.005A1 1 0 011.5 20v-5h2v4zM22.5 20a1 1 0 01-1 1h-5v-2h4v-4h2v5z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.742 8.034c1.863-.497 4.06-1.106 6.664.052A1 1 0 0119 9v6a1.001 1.001 0 01-1.406.914c-1.895-.842-3.45-.45-5.336.053-1.863.497-4.06 1.105-6.664-.053A1 1 0 015 15V9l.008-.125a1 1 0 011.398-.79c1.895.843 3.45.452 5.336-.05zM17 9.687c-1.636-.53-3.056-.17-4.742.28-1.518.405-3.257.882-5.258.42v3.925c1.636.53 3.056.172 4.742-.278 1.518-.405 3.257-.883 5.258-.42V9.686z\" fill=\"#7B61FF\"/><path d=\"M7.5 5h-4v4h-2V4a1 1 0 011-1h5v2zM21.5 3a1 1 0 011 1v5h-2V5h-4V3h5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};